class @App.Clubs.ClubsApplicationsThankYouView
  constructor: ->
    @bindElements()

  bindElements: ->
    BetterModals.showModal($('#modalExistsNotice')) if $('#modalExistsNotice').length

$ ->
  new App.Clubs.ClubsApplicationsThankYouView() if $('.clubsApplicationsThankYouView').length
